import React, { useEffect } from "react";
import { Pagination } from "react-bootstrap";

function PaginationDiv({ newPage, paginationData }) {
  useEffect(() => {
    const pathName = window.location.pathname;
    if (
      pathName.includes("all-leads") ||
      pathName.includes("new-leads") ||
      pathName.includes("all-cases")
    ) {
      newPage(1);
    }
    else{
      return;
    }
  }, [window.location.pathname]);
  const handlePaginationClick = (page) => {
    newPage(page);
  };

  const generatePaginationItems = () => {
    const { page, pageCount } = paginationData;
    const visiblePageNumbers = [];
    const maxVisiblePages = 5; // Maximum number of visible page numbers

    if (pageCount === 1) {
      visiblePageNumbers.push(
        <Pagination.Item
          key={1}
          active={page === 1}
          onClick={() => handlePaginationClick(1)}
        >
          {1}
        </Pagination.Item>
      );
      return visiblePageNumbers;
    }

    visiblePageNumbers.push(
      <Pagination.Item
        key={1}
        active={page === 1}
        onClick={() => handlePaginationClick(1)}
      >
        1
      </Pagination.Item>
    );

    let start = Math.max(2, page - 2);
    let end = Math.min(pageCount - 1, page + 2);

    if (end - start < maxVisiblePages - 2) {
      const diff = maxVisiblePages - 2 - (end - start);
      if (start === 2) {
        end = Math.min(end + diff, pageCount - 1);
      } else {
        start = Math.max(start - diff, 2);
      }
    }

    if (start > 2) {
      visiblePageNumbers.push(<Pagination.Ellipsis key="start-ellipsis" />);
    }

    for (let i = start; i <= end; i++) {
      visiblePageNumbers.push(
        <Pagination.Item
          key={i}
          active={page === i}
          onClick={() => handlePaginationClick(i)}
        >
          {i}
        </Pagination.Item>
      );
    }

    if (end < pageCount - 1) {
      visiblePageNumbers.push(<Pagination.Ellipsis key="end-ellipsis" />);
    }

    visiblePageNumbers.push(
      <Pagination.Item
        key={pageCount}
        active={page === pageCount}
        onClick={() => handlePaginationClick(pageCount)}
      >
        {pageCount}
      </Pagination.Item>
    );

    return visiblePageNumbers;
  };

  return (
    <div className="d-flex justify-content-center border-0 align-items-center pt-3">
      <Pagination>
        <Pagination.First onClick={() => handlePaginationClick(1)} />
        <Pagination.Prev
          className="border-0"
          onClick={() => handlePaginationClick(paginationData.page - 1)}
          disabled={paginationData.page === 1}
        />

        {generatePaginationItems()}

        <Pagination.Next
          onClick={() => handlePaginationClick(paginationData.page + 1)}
          disabled={paginationData.page === paginationData.pageCount}
        />
        <Pagination.Last
          onClick={() => handlePaginationClick(paginationData.pageCount)}
        />
      </Pagination>
    </div>
  );
}

export default PaginationDiv;
